import { render } from "./BootSpinner.vue?vue&type=template&id=1f7543e6"
import script from "./BootSpinner.vue?vue&type=script&lang=js"
export * from "./BootSpinner.vue?vue&type=script&lang=js"

import "./BootSpinner.vue?vue&type=style&index=0&id=1f7543e6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__